import { useAppModal, AppModals } from '@/context/ModalProvider'
import { Button } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next/pages'

export const AutofillButton = ({ mode }: { mode: 'drand' | 'drng' }) => {
  const { t } = useTranslation()
  const modal = useAppModal()

  const { setValue, trigger } = useFormContext()

  return (
    <Button
      onClick={() => {
        modal.openModalNew(AppModals.VerifyAutofill, {
          mode: mode,
          onConfirm: (block: number, signature: string) => {
            setValue('vblock', block)
            setValue('signature', signature)
            trigger('signature')
          },
        })
      }}
      variant={'unstyled'}
      h={'auto'}
      py={1}
      bg={'ninja.300'}
      rounded={'full'}
      px={2}
      fontWeight={700}
      fontSize={'xs'}
    >
      {t('verify.autofill')}
    </Button>
  )
}
